import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { LayoutBleed, Suspense } from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { BioPdfDownloadItem } from './BioPdfDownloadItem';

export type BioPdfDownloadEntry = {
  candidateId: Candidate['id'];
  isAnonymous: boolean;
};

export const BioPdfDownload = ({
  name = 'BIO_PDF_DOWNLOAD',
  queue,
  hideAllHighlights = false,
  hideLocation = false,
  onComplete,
}: {
  name?: string;
  queue: BioPdfDownloadEntry[];
  hideAllHighlights?: boolean;
  hideLocation?: boolean;
  onComplete: () => void;
}) => {
  const [index, setIndex] = useState(0);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (index >= queue.length) {
      onCompleteRef.current();
    }
  }, [index, queue.length]);

  const current = queue[index];

  if (!current) {
    return null;
  }

  return createPortal(
    <LayoutBleed>
      <div data-test={name}>
        <Suspense fallback={null}>
          <BioPdfDownloadItem
            key={current.candidateId}
            name="BIO_PDF_DOWNLOAD_ITEM"
            candidateId={current.candidateId}
            isAnonymous={current.isAnonymous}
            hideAllHighlights={hideAllHighlights}
            hideLocation={hideLocation}
            onSave={() => {
              setIndex(prev => prev + 1);
            }}
          />
        </Suspense>
      </div>
    </LayoutBleed>,
    document.body
  );
};
